import classcat from "classcat";
import React from "react";

import { IconArrowLeft } from "@touchtech/web-baselayer-ui";

import css from "./ExternalPage.module.css";

type Props = {
  handleClose: () => void;
  src?: string;
};

const ExternalPage = ({ handleClose, src }: Props) => (
  <div className={css.container}>
    <button
      className={classcat(["text-headline-3xl", css.backContainer])}
      onClick={handleClose}
    >
      <IconArrowLeft />
    </button>
    <iframe className={css.iframe} src={src} allowFullScreen />
  </div>
);
export default ExternalPage;
